import { Button } from 'blaze-ui/Button'
import { Field as BaseField } from 'components/Wizards/MobileWizards/Field/Field'
import { TimeOfDay, CustomTime } from '../types'
import Styles from './DayTimeSelector.module.scss'
import { useState } from 'react'
import { TimeOfDayWithInlinePicker } from '../TimeOfDayWithInlinePicker'

interface DayTimeSelectorProps {
  selectedDay: string
  currentSelection: TimeOfDay
  currentCustomTime?: CustomTime
  onSave: (timeType: TimeOfDay, customTime?: CustomTime) => void
  onBack: () => void
}

export const DayTimeSelector = ({
  selectedDay,
  currentSelection,
  currentCustomTime,
  onSave,
  onBack,
}: DayTimeSelectorProps) => {
  const [selectedOption, setSelectedOption] = useState<TimeOfDay>(currentSelection)
  const [customTime, setCustomTime] = useState<CustomTime | undefined>(currentCustomTime)

  const handleOptionChange = (timeOfDay: TimeOfDay, newCustomTime?: CustomTime) => {
    setSelectedOption(timeOfDay)
    setCustomTime(newCustomTime)
  }

  const handleSave = () => {
    onSave(selectedOption, customTime)
  }

  return (
    <div className={Styles.container}>
      <BaseField label="Choose time of day to post at">
        <TimeOfDayWithInlinePicker
          value={selectedOption}
          customTime={customTime}
          onChange={handleOptionChange}
          ariaLabel="Day Time Options"
          className={Styles.radioGroup}
          radioOptionClassName={Styles.radioOption}
          selectedClassName={Styles.selected}
          radioLabelClassName={Styles.radioLabel}
          optionTitleClassName={Styles.optionTitle}
          optionDescriptionClassName={Styles.optionDescription}
          showDescriptions={true}
        />
      </BaseField>

      <div className={Styles.buttonContainer}>
        <Button size="lg" variant="primary" fullWidth onPress={handleSave}>
          Save
        </Button>
      </div>
    </div>
  )
}
